import { render, staticRenderFns } from "./PassengerFlowMonth.vue?vue&type=template&id=7630244b&scoped=true&"
import script from "./PassengerFlowMonth.vue?vue&type=script&lang=js&"
export * from "./PassengerFlowMonth.vue?vue&type=script&lang=js&"
import style0 from "./PassengerFlowMonth.vue?vue&type=style&index=0&id=7630244b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7630244b",
  null
  
)

export default component.exports